var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"related-tags"},[_c('h1',[_vm._v("Related Tags")]),_c('div',{staticClass:"btns row"},_vm._l((_vm.tags),function(tag,i){return _c('div',{key:i,staticClass:"tech-btn"},[_vm._v("\n      "+_vm._s(tag.text)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }